const mutations = {
  setPPOBTransactions(state, ppob_transactions) {
    state.ppob_transactions = ppob_transactions;
  },
  setPPOBTransaction(state, ppob_transaction) {
    state.ppob_transaction = ppob_transaction
  },
};

export default mutations;